import React from 'react';
import { Alert } from '@material-ui/lab';
const QuestionViewerHint = ({ visible, hint }) => {
    if (!visible) {
        return null;
    }
    return (React.createElement(Alert, { severity: "info", "data-testid": "questionView-hint" },
        React.createElement("em", null,
            "Hint: ",
            hint)));
};
export default QuestionViewerHint;
//# sourceMappingURL=index.js.map